import "./index.scss"
import AnimatedLetters from "../AnimatedLetters"
import { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faJava,
  faJsSquare,
  faAngular,
  faDocker,
  faReact,
  faGitAlt,
} from "@fortawesome/free-brands-svg-icons"
import Loader from "react-loaders"
import { Link } from "react-router-dom"

const About = () => {
  const [letterClass, setLetterClass] = useState("text-animate")

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover")
    }, 3000) //animation 3s
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone-about">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                "A",
                " ",
                "P",
                "r",
                "o",
                "p",
                "o",
                "s",
                " ",
                "d",
                "e",
                " ",
                "m",
                "o",
                "i",
              ]}
              index={15}
            />
          </h1>

          <p>
            Curieux, rigoureux, dynamique et autonome, je suis ingénieur en{" "}
            <span className="keyword-highlight">
              systèmes d'information et données
            </span>
            , diplômé du{" "}
            <span className="keyword-highlight">
              Département des Sciences et Techniques de l'Ingénieur (DSTI)
            </span>{" "}
            de l'École Supérieure Polytech Diamniadio de l'université Amadou
            Mahtar MBOW de Dakar. Passionné par{" "}
            <span className="keyword-highlight">l'Ingénierie Logicielle</span>,{" "}
            <span className="keyword-highlight">le DevSecOps</span> et{" "}
            <span className="keyword-highlight">
              l'Intelligence Artificielle
            </span>
            , j'ai depuis mon plus jeune âge été captivé par la logique et les
            technologies numériques. Mon parcours m'a permis de structurer cette
            passion pour concevoir des{" "}
            <span className="keyword-highlight">
              solutions innovantes, intelligentes et à fort impact
            </span>
            .
          </p>

          <p>Ma formation inclut le parcours académique suivant :</p>

          <ul className="education-list">
            <li className="education-item">
              <p className="education-title">
                <strong>Cycle d'Ingénieur</strong> (Master/Ingénieur en Systèmes
                d'Information et Données) -{" "}
                <span className="education-meta">
                  <a href="https://polytech.sn/">
                    École Supérieure Polytech Diamniadio (UAM)
                  </a>{" "}
                  <span className="education-period">2023 - 2025</span>
                </span>
              </p>
              <p>
                J'ai consolidé mes compétences en gouvernance des SI, cloud
                computing, data engineering, IA et sécurité avancée. Cette
                formation m'a permis d'aborder l'informatique comme un levier
                stratégique pour les entreprises.
              </p>
              <p>
                <strong>Technologies</strong> :
                <span className="technologies"> React.js</span>,
                <span className="technologies"> TypeScript</span>,
                <span className="technologies"> Next.js</span>,
                <span className="technologies"> Angular</span>,
                <span className="technologies"> Node.js</span>,
                <span className="technologies"> Spring Boot</span>,
                <span className="technologies"> MySQL</span>,
                <span className="technologies"> MongoDB</span>,
                <span className="technologies"> PostgreSQL</span>,
                <span className="technologies"> Docker</span>,
                <span className="technologies"> Kubernetes</span>,
                <span className="technologies"> GitLab</span>,
                <span className="technologies"> Jenkins</span>,
                <span className="technologies"> Python</span>.
              </p>
            </li>

            <li className="education-item">
              <p className="education-title">
                <strong>Licence en Ingénierie Informatique</strong> -{" "}
                <span className="education-meta">
                  <a href="https://polytech.sn/">
                    École Supérieure Polytech Diamniadio (UAM)
                  </a>{" "}
                  <span className="education-period">2022 - 2023</span>
                </span>
              </p>
              <p>
                Cette formation m'a orienté vers l'ingénierie logicielle, les
                bases de données, la cybersécurité et le développement web.
              </p>
              <p>
                <strong>Technologies</strong> :
                <span className="technologies"> HTML5</span>,
                <span className="technologies"> CSS3</span>,
                <span className="technologies"> JavaScript</span>,
                <span className="technologies"> React.js</span>,
                <span className="technologies"> MySQL</span>,
                <span className="technologies"> Git & GitHub</span>
              </p>
            </li>

            <li className="education-item">
              <p className="education-title">
                <strong>Classes préparatoires (02 ans)</strong> -{" "}
                <span className="education-meta">
                  <a href="https://polytech.sn/">
                    École Supérieure Polytech Diamniadio (UAM)
                  </a>{" "}
                  <span className="education-period">2020 - 2022</span>
                </span>
              </p>
              <p>
                Durant deux ans intensifs, j'ai acquis une solide base en
                mathématiques, physique, algorithmique et programmation.
              </p>
              <p>
                <strong>Technologies/Modules</strong> :
                <span className="technologies"> C</span>,
                <span className="technologies"> Python</span>,
                <span className="technologies"> Algorithmique</span>,
                <span className="technologies"> POO</span>,
                <span className="technologies"> Mathématiques</span>,
                <span className="technologies"> Sciences Physiques</span>,
                <span className="technologies"> Data Science</span>
              </p>
            </li>
          </ul>

          <p>
            Dans la continuité de ce parcours, je reste pleinement engagé à
            contribuer à des projets ambitieux, innovants et à fort impact. Vous
            pouvez à cet effet consulter mon profil
            <a
              href="https://www.linkedin.com/in/sdley"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>{" "}
            pour découvrir davantage mes expériences et réalisations. Vous
            pouvez également solliciter mon CV via ce
            <Link to="/contact"> formulaire</Link>.
          </p>

          <blockquote className="about-quote" cite="Contact professionnel">
            <span className="about-quote-text">
              Au plaisir de vous lire et d'échanger autour de projets ambitieux
              pour transformer des idées fortes en résultats concrets.
            </span>
          </blockquote>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faJava} color="#f89820" title="Java" />
              <span>Java</span>
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faGitAlt} color="#f05032" title="Git" />
              <span>Git</span>
            </div>
            <div className="face3">
              <FontAwesomeIcon
                icon={faAngular}
                color="#dd0031"
                title="Angular"
              />
              <span>Angular</span>
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faDocker} color="#2496ed" title="Docker" />
              <span>Docker</span>
            </div>
            <div className="face5">
              <FontAwesomeIcon
                icon={faJsSquare}
                color="#f7df1e"
                title="JavaScript"
              />
              <span>JavaScript</span>
            </div>
            <div className="face6">
              <FontAwesomeIcon
                icon={faReact}
                color="#61dafb"
                title="React.js"
              />
              <span>React.js</span>
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
